import React from "react";
import { createTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
export const themes = {
  // primary: "#4FD1C5",
  primary: "#F2F2F7",
  primaryButton: "#84DEB8",
  primaryIndicator: "#84DEB8", //Indicator ,
  primaryHeader: "#607eeb",
  primaryBlue: "#0C8CE9",
  lightShadow: "#feffff",
  headLine: "#000000",
  whiteColor: "white",
  tableHeader: "#4FD1C5",
  taskBorder: "#E9ECEF",
  taskHeader: "#B6B6B6",
  button: "#00cca3",
  tabIndicator: 1,
  allTap: "#065BAA",
  activeTap: "#149611",
  absentTap: "#FF0000",
  permissionTap: "#8B198D",
  breakTap: "#EC00F1",
  onleaveTap: "#CB680D",
  lateTap: "#09AEB9",
  backgroundShadow: "#D9D9D9",
  cardProjectName: "#3C557A",
  secondryButtonColor: "#9C27B0",
  primaryButtonColor: "#1976D2",
  projectActiveTapColor: "#231F1F",
  activeProject: "#21AB79",
  inactiveProject: "#C35353",
  completedProject: "#F41062",
  holdProject: "#F4CC40",
  formBackground: "#f0f3f5",
  sprintBackground: "#898989",
  workingHours: "#081A51",
  dividerBorder: "#B2B2B5",
  tagBlurColor: "#17285C",
  helperTextColor: "#D32F2F",
  newUser: "#7BDDD3",
  allIconColor: "#a6a6a6",
  shadowColor: "#bcb9bd",
  redColor: "red",
  blueColor: "#34c6eb",
  darkBlue: "#1679ca",
  lightGray: "#a1a9b2",
  buttonBorder: "#D0D5DD",
  colorShadow: "#7D8488",
  showSprintColor: "#715E5E",
  taskBtnBck: "#036EFF",
  proWrkFlwClr: "#351EC3",
  greenColor: "#008000",
  purpleColor: "#800080",
  backgroundColor: "#3FCEC6",
  bgIconColor: "#7D7D7D",
  txtErrorColor: "#DB2F2F",
  btnBackgroundColor: "#8BE1D8",
  lightGreen: "#34eb8c",
  lightGreenD: "#5ae879",
  buttonBackground: "#cccccc",
  sidebarDivider: "#E0E0E0",
  generalSubHeader: "#A2A3A7",
  yellowColor: "#ffcc00",
  lightRedColor: "#ff5d5d",
  lightYellowColor: "#fffd8d",
  balanceColor: "#B79B08",
  lightOrange: "#FF9169",
  white: "#FFFFFF",
  shadowText: "#8C94A3",
  lightBrown: "#d9d9d9",
  leaveBrown: "#9b4c2f",
  backgroundRed: "#f09ca4",
  halfDay: "#6B3E3E",
  loginImage: "#09BD71",
  grayColor: "#3a4855",
  lightBlue: "#bddeff",
  darkPrimary: "#e8e8e8",
  shadowBackGround: "#EFF5F7",
  gradient: "#3f4d7f",
  pinkColor: "#fd71fe",
  downloadIconColor: "#25B7D3",
  darkGray: "#818387",
  closeIcon: "#8E99A4",
  disabledColor: "#f0f0f0",
  disable: "#a3a3c2",
  earlyExit: "#4080bf",
  out: "#8a8a5c",
  planned: "#669999",
  unassigned: "#8c8c8c",
  weekoff: "#ffbb99",
  holiday: "#c6538c",
  darkGreen: "#188c5a",
  editIconColor: "#609cbf",
  miliedRedColor: "#ffcccc",
  whiteSmoke: "#f5f5f5",
  paleGray: "#f0f1ed",
  indogo: "#3f51b5",
  miliedLightGray: "#E5E7EB",
  miliedLightBlue: "#F0F7FF",
  lightGradient: "#EEBD68",
  paleYellow: "#FDE68A",
  mintGreen: "#A7F3D0",
  softSkyBlue: "#BFDBFE",
  lightPink: "#FBCFE8",
  roseBlush: "#FECACA",
  lavender: "#E9D5FF",
  paleAqua: "#D1FAE5",
  babyCoral: "#FDE2E2",
  cream: "#FFF5CC",
  royalBlue: "#1D4ED8",
  babyBlue: "#e3f2fd",
  palepink: "#ffebee",
  pastelPurple: "#f3e5f5",
  palegreen: "#e8f5e8",
  peachtint: "#fff3e0",
  pinkishred: "#ef9a9a",
  lavenderpurple: "#ce93d8",
  freshgreen: "#c8e6c9",
  goldenYellow: "#ffcc02",
  stepActiveColor: "#00D4AA",
  mutedgreen: "#95bf9f",
  softMutedGreen: "#09bd71",
  mutedpurple: "#4f3b5f",
};

export const tableContainerSx = {
  ml: 2,
  mr: 2,
  width: "100%",
  maxHeight: { xs: 150, sm: 300, md: 400, lg: 700, xl: 750 },
};

export const tableContainerSxWithCompany = {
  padding: 1,
  width: "100%",
  maxHeight: { xs: 150, sm: 300, md: 400, lg: 650, xl: 700 },
};

export const cardBorder = {
  borderLeft: `5px solid ${themes?.stepActiveColor}`,
  borderTop: `1px solid ${themes?.stepActiveColor}`,
  borderRight: `1px solid ${themes?.stepActiveColor}`,
  borderBottom: `1px solid ${themes?.stepActiveColor}`,
  borderRadius: 2,
};

export const iconStyle = {
  border: "1px solid #ccc",
  borderRadius: "8px",
  padding: "8px",
};

export const tableHeaderSx = {
  backgroundColor: themes.primary,
  position: "sticky",
  top: -1,
  zIndex: 10,
};

export const optionalAvathar =
  "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export const tableRowSx = {
  "& .MuiTableCell-root": {
    height: "10px",
    padding: "3px 15px",
  },
};

export const tableRowSize = {
  cursor: "pointer",
  transition: "background-color 0.3s",
  "& td, & th": {
    padding: "10px 8px",
    lineHeight: 1.2,
  },
  "&:hover": {
    backgroundColor: themes?.primary,
  },
};

export const stickyHeader = {
  backgroundColor: themes.primary,
  position: "sticky",
  top: -1,
  zIndex: 10,
};

export const tableCellFontSize = { xs: 6, sm: 8, md: 10, lg: 12, xl: 15 };

export const sideBarWidth = 280;

export const deleteText = "Delete Confirmation";
export const deactivateText = "Confirm Deactivate";
export const unSavedText = "Unsaved Changes";

export const deleteMessage = (name) =>
  `Are you sure you want to delete ${
    name || "this item"
  }? This action cannot be undone.`;
export const unSavedMessage =
  "You have unsaved changes. Are you sure you want to exit? Your changes will be lost.";

export const headerMessage = (headerName, headerDescription) => {
  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        {headerName}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {headerDescription}
      </Typography>
    </Box>
  );
};

export const theme = createTheme({
  palette: {
    primary: {
      main: "#00D4AA",
    },
    secondary: {
      main: "#6c757d",
    },
  },
  typography: {
    fontFamily:
      '"Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  },
});

export const drawerStyle = {
  "& .MuiDrawer-paper": {
    width: "680px",
    maxWidth: "90vw",
    backgroundColor: themes?.themes?.whiteColor,
  },
};

export const drawerMediumWidth = {
  "& .MuiDrawer-paper": {
    width: "900px",
    maxWidth: "90vw",
    backgroundColor: themes?.themes?.whiteColor,
  },
};

export const displayFlexItem = {
  display: "flex",
  alignItems: "center",
  gap: 1,
};

export const doubleArrowStyle = {
  color: themes?.grayColor,
  "&:hover": {
    backgroundColor: themes?.whiteColor,
  },
};

export const parentBoxStyle = {
  height: "100vh",
  display: "flex",
  flexDirection: "column",
};

export const childBoxStyle = {
  display: "flex",
  flexDirection: "column",
  gap: 3,
  ml: 1.5,
};

export const childBoxStyleSpaceBetween = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  px: 1,
};

export const childBoxStyleWithColor = {
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  padding: 1,
  backgroundColor: themes?.primary,
};

export const infoStyle = {
  variant: "body2",
  color: "text.secondary",
  sx: { mb: 0.5 },
};

export const toAlignEnd = {
  display: "flex",
  gap: 2,
  justifyContent: "flex-end",
};

export const deleteIconStyle = {
  color: themes?.redColor,
  backgroundColor: themes?.primary,
  borderRadius: "50%",
  "&:hover": { backgroundColor: themes?.primary },
  mt: 0.5,
};

export const editIconStyle = {
  color: themes?.greenColor,
  backgroundColor: themes?.primary,
  borderRadius: "50%",
  "&:hover": { backgroundColor: themes?.primary },
  mr: 2,
  mt: 0.5,
};

export const scrollTop = (tableContainerRef) => {
  if (tableContainerRef.current) {
    tableContainerRef.current.scrollTop = 0;
  }
};

export const sideBarIcon = {
  color: themes.redColor,
  stroke: themes.redColor,
  strokeWidth: 1.5,
  fill: "transparent",
  opacity: 0.8,
};

export const getOrdinal = (n) => {
  if (!n) return "";
  const s = ["th", "st", "nd", "rd"];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const StatusBadge = ({ color, label }) => {
  // const color = statusColors[statusId] || "#BDBDBD";

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: color,
        }}
      />
      <Typography variant="body2">{label}</Typography>
    </Box>
  );
};

export const getStatusFlow = (expandedData) => ({
  Pending: [
    {
      status: "applied",
      user: expandedData?.applied_by,
      date: expandedData?.applied_on,
    },
    ...(expandedData?.reason
      ? [
          {
            status: "reason",
            user: expandedData?.reason,
          },
        ]
      : []),
  ],

  Approved: [
    {
      status: "applied",
      user: expandedData?.applied_by,
      date: expandedData?.applied_on,
    },
    ...(expandedData?.reason
      ? [
          {
            status: "reason",
            user: expandedData?.reason,
          },
        ]
      : []),
    {
      status: "approved",
      user: expandedData?.approved_by,
      date: expandedData?.approved_at ?? expandedData?.approved_on,
    },
  ],

  Rejected: [
    {
      status: "applied",
      user: expandedData?.applied_by,
      date: expandedData?.applied_on,
    },
    ...(expandedData?.reason
      ? [
          {
            status: "reason",
            user: expandedData?.reason ? expandedData?.reason : "N/A",
          },
        ]
      : []),
    {
      status: "rejected",
      user: expandedData?.rejected_by,
      date: expandedData?.rejected_at,
    },
    ...(expandedData?.rejected_reason
      ? [
          {
            status: "rejectReason",
            user: expandedData?.rejected_reason
              ? expandedData?.rejected_reason
              : "N/A",
          },
        ]
      : []),
  ],
});

export const StatusType = (type, bg) => {
  return {
    background: bg || "#ccc",
    // color: colorSet.color || "#000",
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "12px",
    display: "inline-block",
  };
};

export const validateFormulaPattern = (expr) => {
  if (!expr) return false;
  expr = expr.toUpperCase().replace(/\s+/g, "");
  if (!/^[A-Z0-9.+\-*/()]+$/.test(expr)) return false;
  let stack = 0;
  for (const c of expr) {
    if (c === "(") stack++;
    if (c === ")") stack--;
    if (stack < 0) return false;
  }
  if (stack !== 0) return false;
  if (/[*+/-]{2,}/.test(expr.replace(/^-/, ""))) return false;
  if (/[A-Z]+[0-9]+[A-Z]+/.test(expr)) return false;
  if (/[0-9]+[A-Z]+/.test(expr)) return false;
  if (/[A-Z]+[0-9]+/.test(expr)) return false;
  if (/^[*/+]/.test(expr) || /[*/+]$/.test(expr)) return false;

  return true;
};

export const adminRoleName = "Super Admin";
export const supportLabel = "Support Admin";
export const teamLeadLabel = "Team Lead";

export const nameLength = 100;

export const weeks = [
  {
    id: 1,
    weeks: "One Week",
    label: "One Week",
  },
  {
    id: 2,
    weeks: "Two Weeks",
    label: "Two Weeks",
  },
  {
    id: 3,
    weeks: "Three Weeks",
    label: "Three Weeks",
  },
  {
    id: 4,
    weeks: "Four Weeks",
    label: "Four Weeks",
  },
  {
    id: 5,
    weeks: "Five Weeks",
    label: "Five Weeks",
  },
  {
    id: 6,
    weeks: "Six Weeks",
    label: "Six Weeks",
  },
  {
    id: 7,
    weeks: "Custom",
    label: "Custom",
  },
];

export const taskPriority = [
  {
    id: 1,
    priority: "Low",
    label: "Low",
  },
  {
    id: 2,
    priority: "Medium",
    label: "Medium",
  },
  {
    id: 3,
    priority: "High",
    label: "High",
  },
];

export const taskTypeArr = [
  {
    id: 1,
    label: "All",
  },
  {
    id: 2,
    label: "Parent Task",
  },
  {
    id: 3,
    label: "Child Task",
  },
];

export const toastContainerStyle = {
  width: "500px",
  margin: "0 auto",
  position: "fixed",
  top: "0",
  left: "0",
  right: "0",
};

export const changePassword = {
  successType: "success",
  successAlert:
    "You have successfully changed your password.Please logout and login with new password ",
  failureType: "danger",
  failureAlert: "Old Password incorrect",
};
export const defaultLead = null;
export const selectedField = null;
export const buttonAndTableHeaderColor = {
  button: "#8BE1D8",
  TableHeader: "#4FD1C5",
  formHeader: "#4FD1C5",
};

export const subMenuIndicator = {
  indicator: "#C1EEEA",
};

export const gender = [
  { id: 1, gender: "Male", label: "Male" },
  { id: 2, gender: "Female", label: "Female" },
];

export const country = [
  { id: 1, country: "Oman", label: "Oman" },
  {
    id: 2,
    country: "India",
    label: "India",
  },
];

export const countryState = [
  { id: 1, stateName: "Tamil Nadu", countryId: 2 },
  {
    id: 2,
    stateName: "Punjab",
    label: "Punjab",
    countryId: 2,
  },
  {
    id: 3,
    stateName: "Kerala",
    label: "Kerala",
    countryId: 2,
  },
  {
    id: 4,
    stateName: "Al Buraimi",
    label: "Al Buraimi",
    countryId: 1,
  },
  {
    id: 5,
    stateName: "Muscat",
    label: "Muscat",
    countryId: 1,
  },
  {
    id: 6,
    stateName: "Muscat",
    label: "Muscat",
    countryId: 1,
  },
];

//User management  search keys

export const employeeCardKeys = ["user_name", "designation"];
export const employeeListKeys = [
  "user_name",
  "user_code",
  "department",
  "employment_type",
  "company_name",
  "designation",
  "department_lead_name",
  "system_access",
  "status",
  "type",
];
export const teamCardKeys = ["team_name", "team_lead_name", "proxy_name"];
export const teamListKeys = [
  "team_name",
  "team_lead_name",
  "email",
  "proxy_name",
  "created",
];

//Permission Type on Leave apply screen

export const PermissionType = [
  {
    id: 1,
    permissionType: "Bus Late",
  },
  {
    id: 2,
    permissionType: "Medical Emergency ",
  },
  {
    id: 3,
    permissionType: "Others",
  },
];

export const statusType = [
  {
    name: "All",
  },
  { name: "Active" },

  {
    name: "Inactive",
  },
];

export const siteSettingsEditToastMessage = {
  editMessage: "Site status updated successfully",
};

export const leaveTaxYear = [
  {
    year: "2023-2024",
    label: "2023-2024",
    yearDate: "2023-2024 (01/04/2023 - 31/03/2024)",
  },
  {
    year: "2024-2025",
    label: "2024-2025",
    yearDate: "2024-2025 (01/04/2024 - 31/03/2025)",
  },
  {
    year: "2025-2026",
    label: "2025-2026",
    yearDate: "2025-2026 (01/04/2025 - 31/03/2026)",
  },
  {
    year: "2026-2027",
    label: "2026-2027",
    yearDate: "2026-2027 (01/04/2026 - 31/03/2027)",
  },
];

export const dateLabels = [
  {
    dateLabel: "This week",
    label: "This week",
  },
  {
    dateLabel: "Last week",
    label: "Last week",
  },
  {
    dateLabel: "This month",
    label: "This month",
  },
  {
    dateLabel: "Last month",
    label: "Last month",
  },
  {
    dateLabel: "This year",
    label: "This year",
  },
  {
    dateLabel: "Last year",
    label: "Last year",
  },
  {
    dateLabel: "Custom",
    label: "Custom",
  },
];

export const dateFormat = "DD-MM-YYYY";
export const yearMonth = "YYYY-MM-DD";
//Project screen filter

export const filterProject = [
  "projectname",
  "clientName",
  "project_lead_name",
  "projectType",
  "status",
  "completed_tasks",
  "total_tasks",
  "date",
];

export const essPermissions = [
  "status",
  "date",
  "start_time",
  "end_time",
  "total_time",
];

export const essApplyLeave = [
  "leave_type",
  "from_date",
  "to_date",
  "business_days",
  "status",
  "description",
];

export const clientFilterKey = [
  "clientname",
  "clientid",
  "address",
  "gstnumber",
  "email",
  "phonenumber",
];

export const defaultAllSelection = 99999;

export const leaveTypeColors = {
  Vacation: "#8272C0",
  Sick: "#F46070",
  Casual: "#EA6EE4",
  Bereavement: "#348A9C",
};

export const leaveFilterKey = [
  "user_name",
  "role",
  "total_leave",
  "planned_leave",
  "taken_leave",
  "available_leave",
];

export const attendanceFilterList = [
  "department_name",
  "department_lead_name",
  "email",
  "proxy_name",
  "created",
];

export const attendanceFilterCard = [
  "department_name",
  "members_count",
  "check_in_count",
];

export const rejectedFilter = [
  "username",
  "department_name",
  "title",
  "option",
  "from_date",
  "to_date",
  "business_days",
  "approver_name",
  "description",
];

export const administrationList = [
  "department_name",
  "department_lead_name",
  "email",
  "proxy_name",
  "username",
  "department_member_name",
  "date_of_join",
  "phonenumber",
  "id",
  "created",
];

export const administrationCard = [
  "department_name",
  "members_count",
  "check_in_count",
];

export const administrationCompanies = [
  "companyname",
  "company_code",
  "gstnumber",
  "email",
  "phonenumber",
  "address",
  "system_access",
  "isactive",
  "isprimary",
];

export const pendingFilter = [
  "username",
  "department_name",
  "business_days",
  "from_date",
  "to_date",
];

export const essLeaveFilter = [
  "leave_type",
  "from_date",
  "to_date",
  "business_days",
  "status",
];

export const essPermissionFilter = [
  "permission_type",
  "date",
  "start_time",
  "end_time",
  "status",
];

export const hrmsEmployeeFliter = [
  "user_name",
  "user_code",
  "employee_id",
  "email",
  "status",
];

export const individualTaskList = [
  "task_code",
  "due_date",
  "taskname",
  "task_owner.username",
  "current_assignee.username",
  "work_flow_status.name",
  "priority.name",
];
export const projectDashboard = [
  "sprints.name",
  "sprints.description",
  "sprints.start_date",
  "sprints.end_date",
  "sprints.status",
  "sprints.total_tasks",
  "sprints.completed_tasks",
];
export const projectMyTaskList = [
  "taskname",
  "task_code",
  "project.projectname",
  "sprint.name",
  "work_flow_status.name",
  "priority.name",
  "due_date",
];

export const sprintTaskDetails = [
  "task_code",
  "taskname",
  "task_owner.username",
  "total_time",
  "due_date",
  "priority.name",
  "work_flow_status.name",
];

export const essMyLeaves = [
  "leave_type",
  "from_date",
  "description",
  "business_days",
];

export const leaveGroupMasterData = [
  "leave_type",
  "leave_per_period",
  "user_name",
  "email",
  "user_code",
];

export const masterUserData = ["user_code", "user_name", "email"];

export const leaveTypeHrms = [
  "leave_type",
  "leave_per_period",
  "can_apply_beyond_balance",
];
export const sitesettingsTeamZone = [
  "location_name",
  "address",
  "radius",
  "tag",
  "username",
  "location_status",
];
export const hrmsEmployee = ["user_name", "employee_id", "email"];
export const userGroupNameFilter = ["name", "users_count"];

export const leavePeriodHrms = [
  "name",
  "period_start",
  "period_end",
  "leave_crediting_day",
];

export const punchInDetails = ["username", "punch_in_count"];

export const leaveGroupHrms = [
  "name",
  "leave_type",
  "leave_per_period",
  "user_name",
  "email",
  "user_code",
];

export const IndividualLeaveGroup = [
  "effective_from",
  "effective_to",
  "last_credited_date",
  "leave_types.name",
  "version",
];

export const paymentBank = [
  "bank_name",
  "nick_name",
  "bank_account_number",
  "bank_branch",
  "bank_ifsc_code",
];

export const filterShiftGrp = [
  "id",
  "name",
  "shift_category_id",
  "shift_category_name",
  "departments",
  "department_count",
  "group_user_count",
];

export const filterShiftGrpMem = [
  "department_id",
  "department_name",
  "employee_id",
  "id",
  "shift_category_id",
  "shift_category_name",
  "username",
];

export const filterShiftAsgn = [
  "shift_assignment_id",
  "name",
  "shift_cycle",
  "start_date",
  "end_date",
  "no_of_cycle",
  "total_period",
  "status",
];

export const leaveCreditingShedule = [
  { label: "Monthly" },
  { label: "Quarterly" },
  { label: "Half Yearly" },
  { label: "Annually" },
];

export const leaveAvailabilityPeriod = [
  { label: "1 Month" },
  { label: "2 Month" },
  { label: "3 Month" },
  { label: "4 Month" },
  { label: "5 Month" },
  { label: "6 Month" },
  { label: "7 Month" },
  { label: "8 Month" },
  { label: "9 Month" },
  { label: "10 Month" },
];

export const checkInPolicyDetails = [
  { id: 1, label: "First In", policy: "first_in" },
  { id: 2, label: "Last In", policy: "last_in" },
];
export const checkOutPolicyDetails = [
  { id: 1, label: "First Out", policy: "first_out" },
  { id: 2, label: "Last Out", policy: "last_out" },
];

//Reports
export const reportNames = [
  {
    label: "Summarized working hours",
  },
  {
    label: "Detailed working hours",
  },
  {
    label: "Punch details",
  },
  {
    label: "Attendance Anomalies Report",
  },
  {
    label: "Daily Report",
  },
  {
    label: "Overtime Report",
  },
  {
    label: "Late Report",
  },
  {
    label: "Leave and Permission Reports",
  },
];

export const reports = [
  {
    id: 1,
    label: "Summarized working hours",
  },
  {
    id: 2,
    label: "Detailed working hours",
  },
  {
    id: 3,
    label: "Punch details",
  },
];

export const AnomalyRepStatus = [
  {
    id: 1,
    label: "All",
  },
  {
    id: 2,
    label: "Missing",
  },
  {
    id: 3,
    label: "Late",
  },
  {
    id: 4,
    label: "Absent",
  },
];

export const employee_use = [
  {
    id: 1,
    label: "Company accommodation",
  },
  {
    id: 2,
    label: "Company transport",
  },
  {
    id: 3,
    label: "Own transport",
  },
];

export const maritial_status = [
  {
    id: 1,
    label: "Single",
  },
  {
    id: 2,
    label: "Married",
  },
];

export const gender_type = [
  {
    id: 1,
    label: "Male",
  },
  {
    id: 2,
    label: "Female",
  },
];

export const salaryType = [
  {
    id: 1,
    label: "Daily",
  },
  {
    id: 2,
    label: "Weekly",
  },
  {
    id: 3,
    label: "Monthly",
  },
];

export const payrollReports = [
  {
    id: 1,
    label: "Salary Statement Report",
  },
  {
    id: 2,
    label: "ESI Report",
  },
  {
    id: 3,
    label: "EPF Report",
  },
  {
    id: 4,
    label: "Employee Bank Details",
  },
];

export const projectReports = [
  {
    id: 1,
    label: "Project Task",
  },
  {
    id: 2,
    label: "User Task",
  },
  {
    id: 3,
    label: "Inprogress Task",
  },
];

export const WorkingHours = [
  {
    id: 1,
    label: "Shift Hours",
  },
  {
    id: 2,
    label: "Working Hours",
  },
];

export const ShiftGradeShift = [
  {
    id: 1,
    label:
      "Calculate working hour as per shift grade . No changes in working hour calculations",
  },
  {
    id: 2,
    label:
      "Adjust the shift hours if the alotted working hour is varies with Grade working hours",
  },
  {
    id: 3,
    label:
      "Adjust the shift hours if the alotted working hour is more than the grade working hours",
  },
  {
    id: 4,
    label:
      "Adjust the shift hours if the alotted working hour is less than the grade working hours",
  },
];

export const textFontSize = {
  formHeaderText: 20,
};

export const timeLineLabelList = [
  {
    id: 1,
    label: "All",
  },
  {
    id: 2,
    label: "Present",
  },
  {
    id: 3,
    label: "Absent",
  },
  {
    id: 4,
    label: "Leave",
  },
  {
    id: 5,
    label: "Half Day",
  },

  {
    id: 6,
    label: "Permission",
  },
  {
    id: 7,
    label: "Missing",
  },

  {
    id: 8,
    label: "Holiday",
  },
  {
    id: 9,
    label: "Week Off",
  },
  {
    id: 10,
    label: "Unassigned",
  },
  {
    id: 11,
    label: "Shift Planned",
  },
  {
    id: 12,
    label: "Not Joined",
  },
];

// export const brightColorCalendar = {
//   textField: {
//     size: "small",
//     width: "60%",
//     sx: {
//       "& .Mui-disabled": {
//         opacity: 1,
//         WebkitTextFillColor: themes.headLine,
//       },
//     },
//     inputProps: {
//       readOnly: true,
//     },
//   },
// };

export const brightColorCalendar = {
  textField: {
    size: "small",
    width: "60%",
    sx: {
      "& .Mui-disabled": {
        opacity: 1,
        WebkitTextFillColor: "#000", // Or use `themes.headLine`
      },
    },
    inputProps: {
      readOnly: true,
      onKeyDown: (e) => {
        const blockedKeys = ["ArrowUp", "ArrowDown"];
        if (blockedKeys.includes(e.key)) {
          e.preventDefault();
          e.stopPropagation(); // prevent MUI internal handling
        }
      },
    },
  },
};

export const brightColorTimePicker = {
  textField: {
    size: "small",
    width: 15,
    sx: {
      "& .Mui-disabled": {
        // color: themes.headLine,
        opacity: 1,
        WebkitTextFillColor: themes.headLine,
      },
    },
  },
};

export const pathAndProducts = [
  {
    pathname: "myzone",
    productname: "My Zone",
  },
  {
    pathname: "teamzone",
    productname: "Team Zone",
  },
  {
    pathname: "payroll",
    productname: "Payroll",
  },
  {
    pathname: "project",
    productname: "Project",
  },
  {
    pathname: "administration",
    productname: "Administration",
  },
  {
    pathname: "hrzone",
    productname: "HR Zone",
  },
  {
    pathname: "crm",
    productname: "CRM",
  },
  {
    pathname: "tracking",
    productname: "Tracking",
  },
  {
    pathname: "support",
    productname: "Support Admin",
  },
];

export const pathAndProductsScreen = [
  {
    pathname: "components",
    productname: "Components",
  },
  {
    pathname: "operations",
    productname: "Operations",
  },
  {
    pathname: "earning",
    productname: "Earnings",
  },
  {
    pathname: "deductions",
    productname: "Deductions",
  },

  {
    pathname: "processing",
    productname: "Payroll Processing",
  },
  {
    pathname: "setup",
    productname: "Setup",
  },

  {
    pathname: "apply",
    productname: "Apply",
  },
  {
    pathname: "calendar",
    productname: "Calendar",
  },
  {
    pathname: "myleaves",
    productname: "My Leaves",
  },
  {
    pathname: "myshift",
    productname: "Shift",
  },
  {
    pathname: "status",
    productname: "Status",
  },
  {
    pathname: "myworkinghours",
    productname: "Working Hours",
  },
  {
    pathname: "payslip",
    productname: "Payslip",
  },
  {
    pathname: "eodreport",
    productname: "EOD Report",
  },
  {
    pathname: "settings",
    productname: "Settings",
  },
  {
    pathname: "settings",
    productname: "Settings",
  },
  {
    pathname: "loans",
    productname: "Loans",
  },
  {
    pathname: "employee",
    productname: "Payroll Employee",
  },
  {
    pathname: "run",
    productname: "Run Payroll",
  },
  {
    pathname: "reports",
    productname: "Reports",
  },
  {
    pathname: "clients",
    productname: "Clients",
  },
  {
    pathname: "project-management",
    productname: "Projects",
  },
  {
    pathname: "dashboard",
    productname: "Projects",
  },
  {
    pathname: "mytask",
    productname: "Tasks",
  },
  {
    pathname: "report",
    productname: "Reports",
  },
  {
    pathname: "companies",
    productname: "Companies",
  },
  {
    pathname: "role",
    productname: "Roles & User Group",
  },
  {
    pathname: "departments",
    productname: "Departments",
  },
  {
    pathname: "department",
    productname: "Departments",
  },
  {
    pathname: "shift",
    productname: "Shift",
  },
  {
    pathname: "workunit",
    productname: "Work Unit",
  },
  {
    pathname: "master",
    productname: "Master",
  },
  {
    pathname: "user",
    productname: "Users",
  },
  {
    pathname: "create",
    productname: "Users",
  },
  {
    pathname: "create_new",
    productname: "Employee",
  },
  {
    pathname: "employees",
    productname: "Employee",
  },
  {
    pathname: "existing",
    productname: "Employee",
  },
  {
    pathname: "timeoff",
    productname: "LMS",
  },
  {
    pathname: "salaryconfig",
    productname: "Salary Configuration",
  },

  {
    pathname: "triphistory",
    productname: "Track",
  },
  {
    pathname: "patroltraking",
    productname: "Patrol",
  },
  {
    pathname: "approve",
    productname: "Approve",
  },
  {
    pathname: "attendance",
    productname: "Attendance",
  },
  {
    pathname: "leave-summary",
    productname: "Leave Summary",
  },
  {
    pathname: "plan-shift",
    productname: "Shift",
  },
  {
    pathname: "sprint",
    productname: "Projects",
  },
  {
    pathname: "bulk",
    productname: "Employee",
  },
  {
    pathname: "attendances",
    productname: "Attendance",
  },
  {
    pathname: "admin",
    productname: "Product Control",
  },
  {
    pathname: "edit",
    productname: "Employee",
  },
  {
    pathname: "task",
    productname: "Projects",
  },
  {
    pathname: "payout",
    productname: "Payout",
  },
  {
    pathname: "contacts",
    productname: "Contacts",
  },
  {
    pathname: "agent",
    productname: "Dashboard",
  },
  {
    pathname: "settings",
    productname: "Settings",
  },
  {
    pathname: "reminder",
    productname: "Reminders",
  },
  {
    pathname: "hr-shift",
    productname: "Shift",
  },
  {
    pathname: "eodreport",
    productname: "EOD Report",
  },
];
